import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/stores/rootStore";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import ColorSettingTool from "../common/ColorSettingTool";

const ColorMobileModal: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { setColorModalOpen, isColorModalOpen } = rootStore.responsiveStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  return (
    <>
      <Modal
        isOpen={isColorModalOpen}
        toggle={() => setColorModalOpen(!isColorModalOpen)}
        className={classNames("homeModal modal-dialog-centered ")}
        contentClassName="customHomeModalContent"
      >
        <ModalHeader
          className={classNames(
            "homeModalHeader",
            theme!.headerColor,
            theme!.headerTextColor
          )}
          // className="screenModalHeader"
          toggle={() => setColorModalOpen(!isColorModalOpen)}
          close={
            <button
              className={classNames(
                "closeHomeModalIcon",
                theme!.headerTextColor
              )}
              onClick={() => setColorModalOpen(!isColorModalOpen)}
            >
              <i className="far fa-times-circle fa-lg"></i>
            </button>
          }
        >
          {t("color_modal_title")}
        </ModalHeader>
        <ModalBody className="customHomeModal ">
          <ColorSettingTool />
        </ModalBody>
      </Modal>
    </>
  );
};

export default observer(ColorMobileModal);
